<template>
  <div class="input-form">
    <v-row no-gutters>
      <v-col cols="5" class="pr-14">
        <InputFormNew
          v-model="inputData.ledgerInfoline1"
          :detail="items.ledgerInfoLine1"
          :rowHeight="inputFormStyle.rowHeight"
          :titleCols="inputFormStyle.titleCols"
          :contentsCols="inputFormStyle.contentsCols"
        >
          <template #orderDate="{ item }">
            <!-- 期間 -->
            <FromToDatePicker v-model="item.orderDate" />
          </template>
          <template #orderMonth="{ item }">
            <!-- 対象月 -->
            <NormalDatePicker v-model="item.orderMonth" type="month" />
          </template>
          <template #supplier="{ item }">
            <!-- 仕入先 -->
            <MultipleSelectSupplierName v-model="item.supplierId" />
          </template>
          <template #customers="{ item }">
            <!-- 顧客 -->
            <MultipleSelectCustomerName v-model="item.customers" />
          </template>
          <template #shipStorage="{ item }">
            <!-- 出庫倉庫 -->
            <MultipleSelectStorageName
              v-model="item.shipStorageIds"
              :hasDefault="false"
            />
          </template>
          <template #loadingStorage="{ item }">
            <!-- 入庫倉庫 -->
            <MultipleSelectStorageName
              v-model="item.loadingStorageIds"
              :hasDefault="false"
            />
          </template>
          <template #adjustStorage="{ item }">
            <!-- 調整倉庫 -->
            <MultipleSelectStorageName
              v-model="item.adjustStorageIds"
              :hasDefault="false"
            />
          </template>
          <template #storage="{ item }">
            <!-- 倉庫 -->
            <MultipleSelectStorageName
              v-model="item.storageIds"
              :hasDefault="false"
            />
          </template>
          <template #displayMethod="{ item }">
            <!-- 表示方法 -->
            <v-select
              v-model="item.displayMethod"
              :items="displayMethodItems"
              item-text="text"
              item-value="value"
              dense
              outlined
              class="original-selectbox"
              hide-details
              :height="inputFormStyle.inputItemHeight"
            />
          </template>
          <template #adjustmentAmountDisplay="{ item }">
            <!-- 調整金額表示 -->
            <v-select
              v-model="item.adjustmentAmountDisplay"
              :items="adjustmentAmountDisplayItems"
              item-text="text"
              item-value="value"
              dense
              outlined
              class="original-selectbox"
              hide-details
              :height="inputFormStyle.inputItemHeight"
            />
          </template>
          <template #createDate="{ item }">
            <!-- 帳票作成期間 -->
            <FromToDatePicker v-model="item.createDate" />
          </template>
          <template #billDate="{ item }">
            <!-- 請求期間 -->
            <FromToDatePicker v-model="item.billDate" />
          </template>
          <template #currency="{ item }">
            <!-- 通貨 -->
            <SelectCurrency v-model="item.currency" />
          </template>
          <template #amount="{ item }">
            <!-- 金額 -->
            <SearchAmountRange v-model="item.amount" />
          </template>
        </InputFormNew>
      </v-col>
      <v-col cols="3">
        <InputFormNew
          v-model="inputData.ledgerInfoline2"
          :detail="items.ledgerInfoLine2"
          :rowHeight="inputFormStyle.rowHeight"
          :titleCols="3"
          :contentsCols="7"
        >
        </InputFormNew>
      </v-col>
      <v-col cols="4">
        <div class="display-items">
          <div
            v-if="items.ledgerInfoLine3.length > 0"
            class="display-items-label"
          >
            {{ $t('common.common_display-product') }}
          </div>
          <div class="display-items-checkbox">
            <div v-for="(item, index) in items.ledgerInfoLine3" :key="index">
              <v-checkbox
                v-model="inputData.ledgerInfoline3[index].check"
                :label="$t(item.text)"
                class="contents pr-4"
                dense
              />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <div
      v-if="ledgerType && ledgerType.value == 'month-end-stock'"
      class="month-end-stock-message-internal"
    >
      {{ $t('common.common_ledger-sheet-month-end-stock-message') }}
      <br />
      {{ $t('common.common_ledger-sheet-month-end-stock-message2') }}
    </div>
    <NormalButton
      class="input-form-button"
      :text="$t('common.common_output')"
      height="50px"
      width="130px"
      textSize="16px"
      @click="clickDataOutputButton"
    />
  </div>
</template>

<script>
import InputFormNew from '@/components/items/Designs/InputFormNew'
import FromToDatePicker from '@/components/items/inputs/FromToDatePicker'
import NormalDatePicker from '@/components/items/inputs/NormalDatePicker'
import { NormalButton } from '@/components/items'
import { commonUtil } from '@/util'
import {
  MultipleSelectSupplierName,
  MultipleSelectCustomerName,
  MultipleSelectStorageName,
  SelectCurrency,
} from '@/components/items/Selectboxes'
import SearchAmountRange from '@/components/layouts/Search/SearchAmountRange'
import {
  LedgerInfoLine1Items,
  LedgerInfoLine2Items,
  LedgerInfoLine3Items,
  DisplayMethodItems,
  AdjustmentAmountDisplayItems
} from './LedgerSheetInputItems'
import moment from 'moment'

export default {
  components: {
    InputFormNew,
    FromToDatePicker,
    NormalDatePicker,
    NormalButton,
    MultipleSelectSupplierName,
    MultipleSelectCustomerName,
    MultipleSelectStorageName,
    SelectCurrency,
    SearchAmountRange
  },
  props: {
    ledgerType: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    ledgerType(n) {
      this.initPulldown(n)
    }
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 9,
      inputItemHeight: '32px'
    },
    inputData: {
      ledgerInfoline1: {},
      ledgerInfoline2: {},
      ledgerInfoline3: []
    },
    items: {
      ledgerInfoLine1: [],
      ledgerInfoLine2: [],
      ledgerInfoLine3: []
    },
    displayMethodItems: [],
    adjustmentAmountDisplayItems: []
  }),
  computed: {
    isShowDisplayMethod() {
      return this.ledgerType.line1
        ? this.ledgerType.line1.some((d) => d === 'displayMethod')
        : false
    }
  },
  mounted() {
    this.initPulldown()
  },
  methods: {
    initInputData() {
      this.items.ledgerInfoLine1 = []
      this.items.ledgerInfoLine2 = []
      this.items.ledgerInfoLine3 = []
      this.displayMethodItems = []
      this.adjustmentAmountDisplayItems = []
      this.inputData.ledgerInfoline1 = {
        orderDate: {
          start: commonUtil.getFirstDateOneMonthAgo(),
          end: commonUtil.getLastDateThisMonth()
        },
        orderMonth: moment(commonUtil.getLastDateThisMonth()).format('YYYY-MM'),
        supplier: [],
        customers: [],
        shipStorageIds: [],
        loadingStorageIds: [],
        adjustStorageIds: [],
        storageIds: [],
        displayMethod: 1,
        adjustmentAmountDisplay: 1,
        createDate: {
          start: commonUtil.getFirstDateOneMonthAgo(),
          end: commonUtil.getLastDateThisMonth()
        },
        billDate: {
          start: commonUtil.getFirstDateOneMonthAgo(),
          end: commonUtil.getLastDateThisMonth()
        },
        amount: {
          min: null,
          max: null
        }
      }
      this.inputData.ledgerInfoline2 = {}
      this.inputData.ledgerInfoline3 = []
    },
    initPulldown(item) {
      if (!item) {
        return
      }
      this.initInputData()
      this.$nextTick().then(() => {
        item.line1.forEach((each) => {
          const data = LedgerInfoLine1Items.find((d) => d.name === each)
          data.text = this.$t(data.text)
          this.items.ledgerInfoLine1.push(data)
        })
        item.line2.forEach((each) => {
          const data = LedgerInfoLine2Items.find((d) => d.name === each)
          data.text = this.$t(data.text)
          this.items.ledgerInfoLine2.push(data)
        })
        item.line3.forEach((each) => {
          const data = LedgerInfoLine3Items.find((d) => d.name === each)
          data.text = this.$t(data.text)
          this.items.ledgerInfoLine3.push(data)
          this.inputData.ledgerInfoline3.push({
            name: data.name,
            param: data.param,
            check: true
          })
        })
        item.displayMethods.forEach((each) => {
          const data = DisplayMethodItems.find((d) => d.name === each)
          data.text = this.$t(data.text)
          this.displayMethodItems.push(data)
        })
        item.adjustmentAmountDisplay.forEach((each) => {
          const data = AdjustmentAmountDisplayItems.find((d) => d.name === each)
          data.text = this.$t(data.text)
          this.adjustmentAmountDisplayItems.push(data)
        })
      })
    },
    clickDataOutputButton() {
      this.$emit('dataOutput', this.inputData, 1)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .textStyle .v-label {
  font-size: 14px;
}

.input-form {
  position: relative;
  min-height: 230px;

  &-button {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .month-end-stock-message-internal {
    position: absolute;
    bottom: 0px;
    left: 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
  }
}

.display-items {
  display: flex;
  margin-top: 10px;

  &-label {
    min-width: 18%;
    margin-top: 10px;
  }

  &-checkbox {
    width: 300px;
    // display: flex;
    // flex-wrap: wrap;
    &::v-deep {
      .v-label {
        color: rgba(0, 0, 0, 0.87);
        font-size: 14px;
      }
    }
    & > div {
      display: inline-block;
      width: 140px;
      height: 40px;
    }
    // &.contents {
    //   min-width: 150px;
    // }
  }
}
</style>
